class Iframe {

	constructor( heightCallback ){
		this.params = new URLSearchParams(location.search);
		this.id = this.params.get('_id');
		this.paused = false;
		window.addEventListener('load', this.dispatchHeight.bind(this), false );
		window.addEventListener('resize', this.dispatchHeight.bind(this), false );
		window.addEventListener('orientationchange', this.dispatchHeight.bind(this), false );
		window.addEventListener('message', this.onMessage.bind(this), false );
		this.dispatchHeight();
		this.lastHeightCheck = new Date().getTime();
		this.lastHeight = 0;
		this.run();
		this.heightCallback = heightCallback;
	}

	onMessage(e){
		var data = e.data;
		switch( data.cmd ){
			case 'mouseup':
			/**
			 * TODO: add mousemove back in; check the event normalization in highcharts
			 * @see https://github.com/highcharts/highcharts/blob/master/ts/Core/Pointer.ts
			 */
			// case 'mousemove': 
			case 'mousedown':
				// we should relay this to our window...
				const opts = {
					bubbles: true,
					cancelable: true,
				};
				if( data.x && data.y ){
					opts.pageX = data.event.pageX - data.x;
					opts.pageY = data.event.pageY - data.y;
				}
				const event = new Event(data.cmd, opts);
				document.dispatchEvent(event);
				break;
			case 'dimensions':
				break;
		}
	}

	pause(){
		this.paused = true;
	}

	unpause(){
		this.paused = false;
	}

	run() {
		var now = new Date().getTime();
		if( now - this.lastHeightCheck  > 250 ){
			this.lastHeightCheck = now;
			this.dispatchHeight();
		}
		requestAnimationFrame(this.run.bind(this));
	}

	dispatchHeight(){
		if( this.paused ){
			return;
		}
		var h = this.heightCallback ? this.heightCallback() : Math.min( document.body.scrollHeight, document.body.offsetHeight );
		if( h != this.lastHeight ){
			this.dispatch( 'height', {
				height: h
			});
			this.lastHeight = h;
		}
	}

	dispatch(eventName, data){
		window.parent.postMessage({
			id: this.id,
			event: eventName,
			data: data
		}, '*');
	}

	scrollTo(scrollTo){
		this.dispatch('scroll', {
			scrollTo
		});
	}

	watchDimensions(){
		this.dispatch('watchDimensions', {});
	}
}

export default Iframe;
